var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bottom-sheet-vue2',{ref:"bottomSheet",attrs:{"max-height":90,"init-sheet-height":300,"close-height-percent":80}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }